import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleEsc = this.handleEsc.bind(this)
    document.addEventListener("keydown", this.handleEsc)
    this.schedulePopup()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEsc)
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  schedulePopup() {
    if (new URLSearchParams(window.location.search).get("newsletter") === "open") {
      document.body.classList.add('popup-open')
      return
    }

    const popupShowedAt = Number(localStorage.getItem('popupShowedAt'))
    const now = Date.now()
    const showAgainMs = 24 * 60 * 60 * 1000

    if (popupShowedAt && now - popupShowedAt < showAgainMs) {
      return
    }

    this.timeout = setTimeout(() => {
      this.timeout = null
      document.body.classList.add('popup-open')
    }, 4000)
  }

  close() {
    document.body.classList.remove('popup-open')
    localStorage.setItem('popupShowedAt', Date.now().toString())
  }

  closeOnBackground(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  handleEsc(event) {
    if (event.key === "Escape" && document.body.classList.contains('popup-open')) {
      this.close()
    }
  }
}
